"use strict";
// TODO - add types
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueIsNotEmptyBasedOnField = void 0;
const valueIsNotEmptyBasedOnField = (value, field) => {
    return field.allowMultiple
        ? value !== null && value.length > 0
        : typeof value === "string"
            ? value.length > 0
            : value !== null;
};
exports.valueIsNotEmptyBasedOnField = valueIsNotEmptyBasedOnField;
//# sourceMappingURL=valueIsNotEmptyBasedOnField.js.map